module.exports = __webpack_public_path__ + "img/mobile-hk.242967fa.jpg";